<template>
  <div>
    <div class="row">
      <div
        v-if="!visaoSimplificada"
        class="col-xs-4 col-sm-3 col-md-2 col-lg-2"
      >
        <div class="form-group">
          <label for="registroANS">1 - Registro ANS <sup>(4)</sup></label>
          <input
            id="registroANS"
            v-model="guia.autorizacao.registroANS"
            data-test-id="input-registroans"
            type="text"
            readonly
            name="registroANS"
            class="form-control"
            placeholder="Registro da operadora na ANS"
          />
        </div>
      </div>
      <div class="col-xs-6 col-sm-4 col-md-3 col-lg-3">
        <div class="form-group">
          <label for="numeroGuia">2 - Número da guia <sup>(5)</sup></label>
          <input
            id="numeroGuia"
            v-model="guia.autorizacao.numeroGuia"
            data-test-id="input-numeroguia"
            :class="{ 'input-sm': visaoSimplificada }"
            type="text"
            readonly
            name="numeroGuia"
            class="form-control"
            placeholder="Número identificador da guia"
            @input="validations.guia.autorizacao.numeroGuia.$touch()"
          />
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-6 col-sm-4 col-md-3 col-lg-3"
      >
        <div
          :class="{
            'has-error':
              validations.guia.autorizacao.numeroGuiaPrincipal.$error,
          }"
          class="form-group"
        >
          <label for="numeroGuiaPrincipal">3 - Número da guia principal</label>
          <input
            id="numeroGuiaPrincipal"
            v-model="guia.autorizacao.numeroGuiaPrincipal"
            data-test-id="input-numeroguiaprincipal"
            type="text"
            name="numeroGuiaPrincipal"
            class="form-control"
            placeholder="Número identificador da guia principal"
            @input="validations.guia.autorizacao.numeroGuiaPrincipal.$touch()"
          />
          <span v-if="validations.guia.autorizacao.numeroGuiaPrincipal.$dirty">
            <span
              v-if="!validations.guia.autorizacao.numeroGuiaPrincipal.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.autorizacao.numeroGuiaPrincipal.$params
                  .maxLength.max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-6 col-sm-3 col-md-2 col-lg-2"
      >
        <div class="form-group">
          <label for="dataAutorizacao">4 - Data da autorização</label>
          <div id="dataAutorizacao" class="input-group">
            <input
              id="dataAutorizacaoValor"
              v-model="guia.autorizacao.dataAutorizacao"
              v-mask="'99/99/9999'"
              data-test-id="input-dataautorizacaovalor"
              type="text"
              name="dataAutorizacaoValor"
              class="form-control"
              placeholder="Data que a autorizaçãoo foi concedida"
            />
            <div class="input-group-addon">
              <span
                type="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="fa fa-calendar" />
              </span>
              <span class="dropdown-menu">
                <li>
                  <DatePicker
                    v-model="guia.autorizacao.dataAutorizacao"
                    :today-btn="false"
                    :clear-btn="false"
                    :format="'dd/MM/yyyy'"
                    :close-on-selected="true"
                    :date-parser="dataParser"
                    class="date-picker"
                  />
                </li>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-6 col-sm-3 col-md-2 col-lg-2">
        <div
          :class="{ 'has-error': validations.guia.autorizacao.senha.$error }"
          class="form-group"
        >
          <label for="senha">5 - Senha</label>
          <input
            id="senha"
            v-model="guia.autorizacao.senha"
            data-test-id="input-senha"
            :class="{ 'input-sm': visaoSimplificada }"
            type="text"
            name="senha"
            class="form-control"
            placeholder="Senha de autorização"
            @input="validations.guia.autorizacao.senha.$touch()"
          />
          <span v-if="validations.guia.autorizacao.senha.$dirty">
            <span
              v-if="!validations.guia.autorizacao.senha.maxLength"
              class="help-block"
              >Campo deve ter no máximo
              {{
                validations.guia.autorizacao.numeroGuiaPrincipal.$params
                  .maxLength.max
              }}
              caracteres.</span
            >
          </span>
        </div>
      </div>
      <div class="col-xs-6 col-sm-3 col-md-2 col-lg-2">
        <div class="form-group">
          <label for="validadeSenha">6 - Validade da senha</label>
          <div
            id="validadeSenha"
            :class="{ 'input-group-sm': visaoSimplificada }"
            class="input-group"
          >
            <input
              id="validadeSenhaValor"
              v-model="guia.autorizacao.validadeSenha"
              v-mask="'99/99/9999'"
              data-test-id="input-validadesenhavalor"
              type="text"
              name="validadeSenhaValor"
              class="form-control"
              placeholder="Data de validade da senha para execução do procedimento"
            />
            <div class="input-group-addon">
              <span
                type="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="fa fa-calendar" />
              </span>
              <span class="dropdown-menu dropdown-menu-right">
                <li>
                  <DatePicker
                    v-model="guia.autorizacao.validadeSenha"
                    :today-btn="false"
                    :clear-btn="false"
                    :format="'dd/MM/yyyy'"
                    :close-on-selected="true"
                    :date-parser="dataParser"
                    class="date-picker"
                  />
                </li>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!visaoSimplificada"
        class="col-xs-6 col-sm-3 col-md-2 col-lg-2"
      >
        <div
          :class="{
            'has-error': validations.guia.autorizacao.dataEmissao.$error,
          }"
          class="form-group"
        >
          <label for="dataEmissao"
            >7 - Data de emissão da guia <sup>(1)</sup></label
          >
          <div id="dataEmissao" class="input-group">
            <input
              id="dataEmissaoValor"
              v-model="guia.autorizacao.dataEmissao"
              v-mask="'99/99/9999'"
              data-test-id="input-dataemissaovalor"
              type="text"
              name="dataEmissaoValor"
              class="form-control"
              placeholder="Data de emissão da guia"
              @input="validations.guia.autorizacao.dataEmissao.$touch()"
            />
            <div class="input-group-addon">
              <span
                type="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="fa fa-calendar" />
              </span>
              <span class="dropdown-menu">
                <li>
                  <DatePicker
                    v-model="guia.autorizacao.dataEmissao"
                    :today-btn="false"
                    :clear-btn="false"
                    :format="'dd/MM/yyyy'"
                    :close-on-selected="true"
                    :date-parser="dataParser"
                    class="date-picker"
                  />
                </li>
              </span>
            </div>
          </div>
          <span v-if="validations.guia.autorizacao.dataEmissao.$dirty">
            <span
              v-if="!validations.guia.autorizacao.dataEmissao.required"
              class="help-block"
              >Campo obrigatório.</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { DatePicker } from 'uiv'

export default {
  name: 'DadosAutorizacao',
  components: { DatePicker },
  directives: { mask: AwesomeMask },
  props: {
    guia: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  methods: {
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
  },
}
</script>
